export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__inner">
          <p>© 2026 Monika Chaudhary</p>
          <p>SDET · Delhi, India</p>
        </div>
      </div>
    </footer>
  );
}
